import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../../HOC/withRouter";
import NoProfileAvatar from "../../../Assets/images/no-profile-avatar.jpg";
import logo from "../../../Assets/images/ordr-chartreuse-logo.svg";
import { ROLE_LOGISTIC, ROLE_SELLER, ROLE_COMMON_CARRIER } from "../../../Config/config";
import { useDispatch, useSelector } from "react-redux";
import "./Header.scss";
import { getFullName, getLocalStorageItem } from "../../../Helper/helper";
import { fetchProfile, resetUserState } from "../../../Store/actions/user.action";
import { resetLogisticState } from "../../../Store/actions/logistic.action";
import { resetSellerState } from "../../../Store/actions/seller.action";
import { getSellerDashboardDetails } from "../../../Store/thunk/user.thunk";
import { profileActiveStatus } from "../../components.utils";
import { RiLayoutGridLine, RiSettings3Line, RiNotification3Line, RiArrowLeftSLine, RiArrowRightSLine } from "@remixicon/react";

const Header = (props) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const isLoggedIn = useSelector((state) => state.userStore.isLoggedIn);

	const { theme, location } = props;
	const [navbar, showNavbar] = useState({});

	const { profileData, dashboardDetails } = useSelector((state) => state.userStore);

	const userDetails = getLocalStorageItem("ORDER_USER_DETAILS");
	const role = userDetails?.role || profileData?.role || localStorage.getItem("ORDER_USER_ROLE");
	const isSeller = role == ROLE_SELLER || role == 2;
	const isLogisticOrCarrier = role == ROLE_LOGISTIC || role == ROLE_COMMON_CARRIER || role == 4 || role == 6;
	const homeRoute = isLogisticOrCarrier ? "/open-orders" : (role == 5 || role == "5" ? "/admin-dashboard" : "/bids");

	useEffect(() => {
		if (isLoggedIn) {
			dispatch(fetchProfile());
			if (isSeller) {
				dispatch(getSellerDashboardDetails());
			}
		}
	}, [isLoggedIn, isSeller]);

	const handleRedirection = async () => {
		const ordrUserDets = getLocalStorageItem("ORDER_USER_DETAILS");
		const currentRole = ordrUserDets?.role || profileData?.role || localStorage.getItem("ORDER_USER_ROLE");
		if (currentRole == ROLE_LOGISTIC || currentRole == ROLE_COMMON_CARRIER || currentRole == 4 || currentRole == 6) {
			navigate("/open-orders");
		} else if (currentRole == ROLE_SELLER || currentRole == 2) {
			navigate("/bids");
		} else if (currentRole == 5 || currentRole == "5") {
			navigate("/admin-dashboard");
		} else {
			navigate("/open-orders");
		}
	};

	const logout = () => {
		localStorage.removeItem("ORDER_AUTH_TOKEN");
		localStorage.removeItem("ORDER_USER_ROLE");
		localStorage.removeItem("ORDER_USER_ID");
		localStorage.removeItem("ORDER_USER_DETAILS");

		dispatch(resetUserState());
		dispatch(resetSellerState());
		dispatch(resetLogisticState());

		navigate("/login");
	};

	return (
		<>
			<nav className="navbar navbar-expand-md">
				<div className="main_logo">
					<div className="header-logo d-flex cursor-pointer" onClick={() => handleRedirection()}>
						<img src={logo} alt="Order-logo" />
						<div className="company-name text-transform-none">
							<span>{(role == ROLE_COMMON_CARRIER || role == 6) ? "Carrier" : (role == ROLE_LOGISTIC || role == 4) ? "Logistics" : (role == 5 || role == "5") ? "Admin" : "Seller"}</span>
							<span>Central</span>
						</div>
					</div>
					<span className="brand-divider" aria-hidden="true"></span>
					<span className="nav-arrows">
						<button className="nav-arrow-btn" type="button" onClick={() => navigate(-1)} aria-label="Go back">
							<RiArrowLeftSLine size={18} />
						</button>
						<button className="nav-arrow-btn" type="button" onClick={() => navigate(1)} aria-label="Go forward">
							<RiArrowRightSLine size={18} />
						</button>
					</span>
				</div>

				{isLoggedIn ? (
					<>
						<button className="navbar-toggler" type="button" onClick={() => showNavbar(!navbar)}>
							<span className="navbar-toggler-icon"></span>
						</button>
						<div className={`collapse navbar-collapse ${navbar ? "show" : ""}`}>
							<ul className="navbar-nav mr-auto w-100">
								<li className="nav-item nav-item-1">
									<Link className={`nav-link ${location.pathname.includes(homeRoute) ? "active" : ""}`} to={homeRoute}>
										<div className="d-flex col-gap-10 align-items-center">
											<RiLayoutGridLine size={18} />
											<b>Dashboard</b>
										</div>
									</Link>

									<Link className={`nav-link ${location.pathname.includes("account-settings") ? "active" : ""}`} to="/account-settings">
										<div className="d-flex col-gap-10 align-items-center">
											<RiSettings3Line size={18} />
											<b> Account settings</b>
										</div>
									</Link>

									{isSeller ? (
										<Link className={`nav-link ${location.pathname.includes("op-settings") ? "active" : ""}`} to="/op-settings">
											<div className="d-flex col-gap-10 align-items-center">
												<RiSettings3Line size={18} />
												<b> Operational settings</b>
											</div>
										</Link>
									) : null}
								</li>

								<li className="nav-item nav-item-2">
									<Link className={`nav-link ${location.pathname.includes("notifications") ? "active" : ""}`} to="/notifications">
										<div className="d-flex col-gap-10 align-items-center position-relative">
											<RiNotification3Line size={18} />
											<b>Message notifications</b>
											{dashboardDetails?.newNotification ? (
												<span
													className="notif-dot"
													role="img"
													aria-label={`${dashboardDetails.newNotification} unread notifications`}
													title={`${dashboardDetails.newNotification} unread notifications`}
												></span>
											) : null}
										</div>
									</Link>
								</li>

								<li className="nav-item nav-item-3">
									<Link className={`nav-link ${location.pathname.includes("profile") ? "active" : ""}`} to="/profile" title={getFullName(profileData.firstName, profileData.lastName)}>
										<span className="header-profile-icon">
											<img src={profileData?.profileImage ? profileData.profileImage : NoProfileAvatar} alt="avatar" state={profileActiveStatus(profileData)} />
										</span>
									</Link>
								</li>

								<li className="nav-item nav-item-4">
									<div className="nav-link">
										<button className=" btn theme-btn" onClick={() => logout()}>
											<b>Log out</b>
										</button>
									</div>
								</li>
							</ul>
						</div>
					</>

				) : null}
			</nav>
			{/* {theme !== "dark" && <div style={{ height: "64px" }}></div>} */}
		</>
	);
};

export default withRouter(Header);
